/**
 * Auth Services Export
 * 
 * Central export point for all authentication services
 */

export { tokenService } from './TokenService';
export type { TokenData, TokenServiceEvents } from './TokenService';

export { secureAuthService } from './SecureAuthService';
export type { LoginCredentials, AuthResult, RequestConfig } from './SecureAuthService';

// Re-export utilities
export { cookieUtils } from '../utils/cookieUtils';
export type { CookieOptions } from '../utils/cookieUtils';

// Re-export components
export { SessionStatusOverlay } from '../components/SessionStatusOverlay';

// Hooks are re-exported here for consumer convenience (no cycle — hooks import
// from leaf service files, not this barrel).
export { useSecureAuth, useRequireAuth } from '../hooks/useSecureAuth';
export { useSecureAuthContext } from '../providers/SecureAuthProvider';
export { useUserIdentity, useIsCurrentUser, useUserDisplay } from '../hooks/useUserIdentity';
// Note: useCurrentUser should be imported directly from '../hooks/useCurrentUser'
// to avoid circular dependencies with API modules